/* Silberkraft-Header (Horizon-Port 30.10.2026) — ES-Modul, kein jQuery, keine Abhängigkeit von empire.js.
   Portiert aus Empire assets/sk-nav-v4.js (Menü v4.1), snippets/site-mobile-nav (Drawer-Aufbau) und sk-nav-click-counter.
   1 Klickzähler · 2 Desktop-Menü (v4 + schlank) · 3 Bilder/Icons lazy · 4 Handy-Drawer (<dialog>) · 5 Handy-Drill-down v4
   · 6 Handy-Akkordeon (schlank) · 7 Warenkorb-Drawer · 8 Chat-Links.
   Events für andere Skripte: document 'sk:mnav-open' / 'sk:mnav-close'; Klasse html.sk-mnav-open solange der Drawer offen ist. */

const header = document.querySelector('[data-sk-header]');
const $ = (s, r = document) => r.querySelector(s);
const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));

/* ── 1 Anonymer Klickzähler (Menü-Neubau 20.10.2026) ─────────────────────────────────────────────
   Je Klick NUR Menü, Ebene, Linkziel, Linktext, Gerätetyp, Sprache, Menüversion per sendBeacon an das ERP.
   Keine Cookies, keine IDs, keine Suchbegriffe. nav-Merkmal: 'horizon-v4' (bzw. 'horizon-<menü>'). */
(function counter() {
  if (window.__skNavCount) return;
  window.__skNavCount = 1;
  const U = 'https://erp-api-289183413262.europe-west1.run.app/public/nav-clicks';
  const NAV = (header && header.dataset.skNav) || 'horizon-unbekannt';
  const LOC = (header && header.dataset.skLocale) || document.documentElement.lang || '';
  const ROOTS = [['#sk-mnav', 'mobile'], ['[data-sk-header-nav]', 'header'], ['[data-sk-live-search-dropdown]', 'search'], ['.sk-footer', 'footer'], ['.sk-header__main', 'header']];
  const dev = () => { const w = window.innerWidth || 1024; return w < 768 ? 'mobile' : w < 1024 ? 'tablet' : 'desktop'; };
  function send(p) {
    Object.assign(p, { device: dev(), locale: LOC, nav: NAV });
    if (window.skIntern) p.i = 1;
    try {
      const b = JSON.stringify(p);
      if (navigator.sendBeacon && navigator.sendBeacon(U, b)) return;
      fetch(U, { method: 'POST', body: b, keepalive: true, mode: 'no-cors' });
    } catch (e) { /* egal */ }
  }
  function txt(a) {
    let t = a.getAttribute('data-sk-nav-text');
    if (!t) { const n = a.querySelector('[class*="title"],[class*="name"]'); t = (n || a).textContent; }
    if (!t || !t.trim()) t = a.getAttribute('aria-label') || a.getAttribute('title') || '';
    return t.replace(/\s+/g, ' ').trim().slice(0, 120);
  }
  document.addEventListener('click', (e) => {
    const a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
    if (!a) return;
    const href = a.getAttribute('href') || '';
    if (href.charAt(0) === '#') return;
    let menu = null, root = null;
    for (const [sel, name] of ROOTS) { root = a.closest(sel); if (root) { menu = name; break; } }
    if (!menu) return;
    const lvl = a.getAttribute('data-sk-level');
    let level = lvl ? +lvl : 0;
    if (!lvl && menu !== 'search' && !(menu === 'header' && root.matches('.sk-header__main'))) {
      for (let el = a.parentElement; el && el !== root; el = el.parentElement) if (el.tagName === 'LI') level++;
    }
    send({ menu, level: Math.max(0, Math.min(3, level || 0)), target: href, text: txt(a) });
  }, true);
  document.addEventListener('submit', (e) => {
    const f = e.target;
    if (!f || !f.getAttribute) return;
    if (!/\/search(\?|$)/.test(f.getAttribute('action') || '')) return;
    send({ menu: 'search', level: 0, target: '/search', text: f.closest('#sk-mnav') ? '(Suche im Handy-Menü abgeschickt)' : '(Suche abgeschickt)' });
  }, true);
})();

/* 31.10.2026 Header-Diät: Panel-Links (Ebene 3) kommen ohne Klasse/Level aus dem Server-HTML (spart ~5 KB je Seite) —
   hier vor allem anderen nachsetzen, damit Icons, Klickzähler und Handy-Menü-Klon unverändert funktionieren. */
$$('.sk-nav4__groups .sk-nav4__list a').forEach((a) => { a.classList.add('sk-nav4__link'); if (!a.hasAttribute('data-sk-level')) a.setAttribute('data-sk-level', '3'); });

/* ── 3 Icons + Menü-Fotos lazy ─────────────────────────────────────────────────────────────────
   Server-HTML je Link nur <a data-ic="…" data-it="…">Titel</a>; beim ersten Öffnen Icon-/Bild-Kachel + Text-Span einsetzen.
   Menü-Fotos (Tierbilder): Shopify Files sk-nav-<motiv>-96.webp / -192.webp (Zuordnung snippets/sk-nav-v4-img.liquid). */
const spriteUrl = ($('[data-sk-nav4-icons]') || { getAttribute: () => '' }).getAttribute('data-sk-nav4-icons');
const TB = '/cdn/shop/files/sk-nav-', TV = '?v=20261030';
function imgUrl(path, px, crop) { return '/cdn/shop/' + path + (path.indexOf('?') < 0 ? '?' : '&') + 'width=' + px + '&height=' + px + (crop ? '&crop=center' : ''); }
function imgTile(el) {
  const it = el.getAttribute('data-it');
  if (it) {
    const w = document.createElement('span'); w.className = 'sk-nav4__im sk-nav4__im--photo'; w.setAttribute('aria-hidden', 'true');
    const i = document.createElement('img'); i.alt = ''; i.width = 40; i.height = 40; i.decoding = 'async'; i.loading = 'lazy'; i.sizes = '40px';
    i.setAttribute('data-src', TB + it + '-96.webp' + TV); i.setAttribute('data-srcset', TB + it + '-96.webp' + TV + ' 96w, ' + TB + it + '-192.webp' + TV + ' 192w');
    w.appendChild(i); return w;
  }
  const crop = el.hasAttribute('data-im'), path = el.getAttribute(crop ? 'data-im' : 'data-ip');
  if (!path) return null;
  const w = document.createElement('span'); w.className = 'sk-nav4__im' + (crop ? ' sk-nav4__im--crop' : ''); w.setAttribute('aria-hidden', 'true');
  const i = document.createElement('img'); i.alt = ''; i.width = 40; i.height = 40; i.decoding = 'async'; i.loading = 'lazy';
  i.setAttribute('data-src', imgUrl(path, 40, crop)); i.setAttribute('data-srcset', imgUrl(path, 40, crop) + ' 1x, ' + imgUrl(path, 80, crop) + ' 2x');
  w.appendChild(i); return w;
}
function loadImgs(root) {
  if (!root) return;
  $$('.sk-nav4__im img[data-src]', root).forEach((i) => {
    i.srcset = i.getAttribute('data-srcset'); i.src = i.getAttribute('data-src'); i.removeAttribute('data-src'); i.removeAttribute('data-srcset');
  });
}
let iconsDone = false;
function warm() {
  loadBest();
  if (iconsDone) return; iconsDone = true;
  $$('a.sk-nav4__link:not([data-done])').forEach((a) => {
    a.setAttribute('data-done', '');
    const ic = a.getAttribute('data-ic');
    if (!a.querySelector('span')) { const t = document.createElement('span'); while (a.firstChild) t.appendChild(a.firstChild); a.appendChild(t); }
    const im = imgTile(a);
    if (im) a.insertBefore(im, a.firstChild);
    else if (ic && spriteUrl) {
      const s = document.createElement('span'); s.className = 'sk-nav4__ic'; s.setAttribute('aria-hidden', 'true');
      s.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><use href="' + spriteUrl + '#ic-' + ic + '"></use></svg>';
      a.insertBefore(s, a.firstChild);
    }
  });
}
$$('[data-sk-nav4-bar]').forEach((b) => { b.addEventListener('pointerenter', warm, { once: true }); b.addEventListener('focusin', warm, { once: true }); });
if (spriteUrl) {
  const pre = () => { const l = document.createElement('link'); l.rel = 'prefetch'; l.href = spriteUrl; l.as = 'image'; document.head.appendChild(l); };
  const idle = () => ('requestIdleCallback' in window ? requestIdleCallback(pre, { timeout: 6000 }) : setTimeout(pre, 3000));
  if (document.readyState === 'complete') setTimeout(pre, 3000); else window.addEventListener('load', idle, { once: true });
}
/** Inaktive <template>-Inhalte (Bestseller, Service-Links, Ebene 3) beim ersten Öffnen einsetzen. */
/* PERF 31.10.2026 (Philipp 31.10.: PDP-Serverzeit): Bestseller-Karten der Panels stehen nicht mehr im Server-HTML (kostete ≈ 50 ms
   Serverzeit je Seitenaufruf ohne Cache), sondern kommen einmalig per Section Rendering (sections/sk-nav4-best) – beim ersten
   Hover/Fokus/Handy-Menü (warm) bzw. bei feiner Maus im Leerlauf nach dem Laden. Füllt die leeren <ul data-sk-nav4-best="N">
   (auch die Klone im Handy-Drill-down). Fehlschlag: Panel ohne Karten, Links bleiben vollständig. */
const bestUrl = ($('[data-sk-nav4-best-url]') || { getAttribute: () => '' }).getAttribute('data-sk-nav4-best-url');
let bestMap = null, bestP = null;
function fillBest() {
  if (!bestMap) return;
  $$('ul[data-sk-nav4-best]').forEach((ul) => {
    if (ul.children.length) return;
    const h = bestMap[ul.getAttribute('data-sk-nav4-best')];
    if (h) ul.innerHTML = h;
  });
}
function loadBest() {
  if (bestP || !bestUrl) return bestP;
  bestP = fetch(bestUrl, { credentials: 'same-origin' })
    .then((r) => (r.ok ? r.text() : Promise.reject(new Error('HTTP ' + r.status))))
    .then((html) => {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      bestMap = {};
      doc.querySelectorAll('[data-sk-nav4-best-src]').forEach((u) => { bestMap[u.getAttribute('data-sk-nav4-best-src')] = u.innerHTML; });
      fillBest();
    })
    .catch(() => { bestP = null; });
  return bestP;
}
if (bestUrl && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
  const preB = () => ('requestIdleCallback' in window ? requestIdleCallback(loadBest, { timeout: 8000 }) : setTimeout(loadBest, 4000));
  if (document.readyState === 'complete') setTimeout(preB, 2000); else window.addEventListener('load', () => setTimeout(preB, 2000), { once: true });
}
function hydrate(p) { if (p) $$('template[data-sk-nav4-tpl]', p).forEach((t) => t.parentNode && t.parentNode.replaceChild(t.content, t)); fillBest(); loadBest(); }
window.SKNav4Hydrate = hydrate;

/* ── 2 Desktop-Menü: Hover-Intent (150 ms auf / 250 ms zu, nur echte Maus) mit Sicherheitsdreieck, Tastatur, Touch-Erst-Tippen ── */
(function desktop() {
  const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');
  const items = $$('[data-sk-nav4-item]');
  let openItem = null, tOpen = 0, tClose = 0;
  let mx = 0, my = 0, pmx = 0, pmy = 0;
  document.addEventListener('mousemove', (e) => { pmx = mx; pmy = my; mx = e.clientX; my = e.clientY; }, { passive: true });
  const top = (it) => it.querySelector('[data-sk-nav4-top]');
  const panel = (it) => it.querySelector('[data-sk-nav4-panel]');
  function towardPanel() {
    if (!openItem) return false;
    const p = panel(openItem); if (!p) return false;
    const r = p.getBoundingClientRect();
    if (my <= pmy || my > r.top + 6) return false;
    const dx = mx - pmx, dy = my - pmy;
    const tx = Math.min(Math.max(mx + dx * ((r.top - my) / Math.max(dy, 0.5)), -1e5), 1e5);
    return tx >= r.left - 24 && tx <= r.right + 24;
  }
  function trySwitch(it, n) {
    if (openItem && openItem !== it && n < 4 && towardPanel()) { tOpen = setTimeout(() => trySwitch(it, n + 1), 140); return; }
    open(it);
  }
  function fit(it) {
    const p = panel(it); if (!p) return;
    warm(); hydrate(p); loadImgs(p);
    p.style.maxHeight = ''; p.style.left = '';
    let r = p.getBoundingClientRect();
    if ((it.classList.contains('sk-nav4__item--compact') || it.classList.contains('sk-snav__item')) && r.right > window.innerWidth - 16) {
      p.style.left = Math.round(window.innerWidth - 16 - r.right) + 'px'; r = p.getBoundingClientRect();
    }
    if (!it.classList.contains('sk-snav__item')) p.style.maxHeight = Math.max(240, window.innerHeight - Math.max(r.top, 0) - 16) + 'px';
  }
  function setState(it, o) { top(it).setAttribute('aria-expanded', o ? 'true' : 'false'); it.classList.toggle('is-open', o); if (o) fit(it); }
  function open(it) { if (openItem === it) return; if (openItem) setState(openItem, false); setState(it, true); openItem = it; }
  function close(it, refocus) { if (!it) return; setState(it, false); if (openItem === it) openItem = null; if (refocus) top(it).focus(); }
  function sibling(it, dir) {
    const tops = $$(':scope > li > a', it.closest('[data-sk-nav4-bar]'));
    const i = tops.indexOf(it.querySelector(':scope > a'));
    return tops[(i + dir + tops.length) % tops.length];
  }
  items.forEach((it) => {
    const t = top(it), p = panel(it);
    if (!t || !p) return;
    t.addEventListener('click', (e) => { if (finePointer.matches) return; if (openItem !== it) { e.preventDefault(); open(it); } });
    t.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowDown' || e.key === ' ' || e.key === 'Spacebar') {
        e.preventDefault(); open(it); const a = p.querySelector('a'); if (a) a.focus();
      } else if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
        e.preventDefault(); if (openItem) close(openItem); const n = sibling(it, e.key === 'ArrowRight' ? 1 : -1); if (n) n.focus();
      }
    });
    p.addEventListener('keydown', (e) => {
      if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
      const links = $$('a', p); const i = links.indexOf(document.activeElement); if (i < 0) return;
      e.preventDefault(); const n = links[i + (e.key === 'ArrowDown' ? 1 : -1)]; if (n) n.focus(); else if (e.key === 'ArrowUp') t.focus();
    });
    it.addEventListener('mouseenter', () => {
      if (!finePointer.matches) return;
      clearTimeout(tClose); clearTimeout(tOpen);
      if (openItem === it) return;
      tOpen = setTimeout(() => trySwitch(it, 0), openItem ? 220 : 150);
    });
    it.addEventListener('mouseleave', () => {
      if (!finePointer.matches) return;
      clearTimeout(tOpen);
      tClose = setTimeout(() => { if (openItem === it) close(it); }, 250);
    });
    it.addEventListener('focusin', () => { hydrate(p); });
    it.addEventListener('focusout', (e) => { if (e.relatedTarget && !it.contains(e.relatedTarget) && openItem === it) close(it); });
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && openItem) close(openItem, true); });
  document.addEventListener('click', (e) => { if (openItem && !openItem.contains(e.target)) close(openItem); });
  window.addEventListener('resize', () => { if (openItem) fit(openItem); });
})();

/* ── 4 Handy-Drawer (<dialog>) mit History: Zurück-Geste geht eine Ebene zurück, auf Ebene 0 schließt sie den Drawer ── */
const dlg = $('[data-sk-mnav]');
const burger = $('[data-sk-burger]');
let depth = 0, quiet = 0, pending = null, lastRow = null;
let remoteP = null;
/** Menü v4: Drawer-Inhalt per Section Rendering (sections/sk-mnav.liquid) einmalig nachladen; bis dahin/bei Fehler bleibt der Sortiment-Link. */
function loadRemote() {
  const box = dlg && $('[data-sk-mnav-remote]', dlg);
  if (!box) return Promise.resolve();
  if (remoteP) return remoteP;
  remoteP = fetch(box.getAttribute('data-sk-mnav-remote'), { credentials: 'same-origin' })
    .then((r) => (r.ok ? r.text() : Promise.reject(new Error('HTTP ' + r.status))))
    .then((html) => {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const m = doc.querySelector('[data-sk-mnav4]');
      if (!m || !box.isConnected) return;
      box.replaceWith(document.importNode(m, true));
      if (isOpen()) rowImgs();
    })
    .catch(() => { remoteP = null; });
  return remoteP;
}
function buildDrawer() {
  if (!dlg) return;
  const t = $('template[data-sk-mnav-tpl]', dlg);
  if (t && t.parentNode) t.parentNode.replaceChild(t.content, t);
  buildSimple();
  loadRemote();
}
const isOpen = () => !!(dlg && dlg.open);
function rowImgs() {
  $$('.sk-mnav4__ic[data-im]:not([data-done]),.sk-mnav4__ic[data-ip]:not([data-done]),.sk-mnav4__ic[data-it]:not([data-done])').forEach((s) => {
    s.setAttribute('data-done', ''); const t = imgTile(s); if (!t) return;
    s.classList.add('sk-mnav4__ic--img'); s.appendChild(t);
  });
  loadImgs($('[data-sk-mnav4-root]'));
}
function openDrawer() {
  if (!dlg || isOpen()) return;
  buildDrawer(); warm();
  dlg.showModal();
  document.documentElement.setAttribute('scroll-lock', '');
  document.documentElement.classList.add('sk-mnav-open');
  requestAnimationFrame(() => dlg.classList.add('is-open'));
  if (burger) burger.setAttribute('aria-expanded', 'true');
  rowImgs();
  if (depth === 0) { try { history.pushState({ skMnav: 1 }, ''); depth = 1; } catch (e) { /* egal */ } }
  document.dispatchEvent(new CustomEvent('sk:mnav-open'));
}
function finishClose() {
  if (dlg.open) dlg.close();
  showRoot(false);
}
function closeDrawer(fromHistory) {
  if (!isOpen()) return;
  dlg.classList.remove('is-open');
  document.documentElement.removeAttribute('scroll-lock');
  document.documentElement.classList.remove('sk-mnav-open');
  if (burger) { burger.setAttribute('aria-expanded', 'false'); }
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce) finishClose(); else { let done = false; const f = () => { if (done) return; done = true; finishClose(); }; dlg.addEventListener('transitionend', f, { once: true }); setTimeout(f, 450); }
  if (!fromHistory && depth > 0) { quiet++; const n = depth; depth = 0; history.go(-n); }
  if (burger) burger.focus({ preventScroll: true });
  document.dispatchEvent(new CustomEvent('sk:mnav-close'));
}
if (dlg && burger) {
  /* Inhalt schon beim ersten Antippen aufbauen (vor dem click) */
  burger.addEventListener('pointerdown', buildDrawer, { once: true, passive: true });
  burger.addEventListener('focus', buildDrawer, { once: true });
  burger.addEventListener('click', () => (isOpen() ? closeDrawer() : openDrawer()));
  dlg.addEventListener('cancel', (e) => { e.preventDefault(); if (subOpen()) back(); else closeDrawer(); });
  dlg.addEventListener('click', (e) => { if (e.target === dlg) closeDrawer(); }); /* Klick auf ::backdrop */
  dlg.addEventListener('focusin', buildDrawer, { once: true });
  $('[data-sk-mnav-close]', dlg)?.addEventListener('click', () => closeDrawer());
  window.matchMedia('(min-width: 1024px)').addEventListener('change', (m) => { if (m.matches && isOpen()) closeDrawer(); });
}

/* ── 5 Handy-Drill-down Menü v4: Ebene 1 aus den Desktop-Panels geklont (Links nur einmal im Server-HTML) ── */
let uid = 0;
function accordion(group, first) {
  const h = group.querySelector('.sk-nav4__h');
  const ul = group.querySelector('ul');
  const wrap = document.createElement('div');
  wrap.className = 'sk-mnav4__acc';
  if (!h) { const plain = ul.cloneNode(true); plain.removeAttribute('aria-labelledby'); plain.className = 'sk-mnav4__list'; wrap.appendChild(plain); return wrap; }
  const id = 'sk-mnav4-acc' + (++uid);
  const b = document.createElement('button');
  b.type = 'button'; b.className = 'sk-mnav4__acc-btn'; b.setAttribute('aria-expanded', first ? 'true' : 'false'); b.setAttribute('aria-controls', id);
  b.innerHTML = '<span></span><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="m6 9 6 6 6-6"/></svg>';
  b.firstChild.textContent = h.textContent;
  const list = ul.cloneNode(true); list.id = id; list.className = 'sk-mnav4__list'; list.removeAttribute('aria-labelledby');
  if (!first) list.hidden = true;
  wrap.appendChild(b); wrap.appendChild(list);
  return wrap;
}
const subEl = () => $('[data-sk-mnav4-sub]');
const subOpen = () => { const s = subEl(); return !!(s && !s.hidden); };
function showSub(pid, row) {
  const p = document.getElementById(pid), sub = subEl(), root = $('[data-sk-mnav4-root]');
  if (!p || !sub || !root) return;
  warm(); hydrate(p);
  sub.innerHTML = '';
  const all = p.querySelector('[data-sk-nav4-all]');
  if (all) { const a = all.cloneNode(true); a.className = 'sk-mnav4__primary'; a.removeAttribute('data-sk-nav4-all'); sub.appendChild(a); }
  $$('[data-sk-nav4-group]', p).forEach((g, i) => sub.appendChild(accordion(g, i === 0)));
  const cards = p.querySelector('[data-sk-nav4-cards]');
  if (cards) {
    const lab = p.querySelector('.sk-nav4__label');
    const box = document.createElement('div'); box.className = 'sk-mnav4__best';
    if (lab) { const l = lab.cloneNode(true); l.className = 'sk-mnav4__label'; box.appendChild(l); }
    const c = cards.cloneNode(true); c.className = 'sk-mnav4__cards'; c.removeAttribute('data-sk-nav4-cards');
    box.appendChild(c); sub.appendChild(box);
  }
  $$('[id]', sub).forEach((el) => { if (el.id.indexOf('sk-mnav4-acc') !== 0) el.removeAttribute('id'); });
  loadImgs(sub);
  setChips(false);
  root.hidden = true; sub.hidden = false;
  $('[data-mobile-nav-panel]')?.classList.add('sk-mnav4-is-sub');
  const t = $('[data-sk-mnav4-title]'); if (t) t.textContent = p.getAttribute('data-sk-nav4-title') || '';
  const bk = $('[data-sk-mnav4-back]'); if (bk) bk.hidden = false;
  const cont = $('[data-sk-mnav-content]'); if (cont) cont.scrollTop = 0;
  if (bk) bk.focus();
  lastRow = row;
  try { history.pushState({ skMnav: 2 }, ''); depth++; } catch (e) { /* egal */ }
}
function showRoot(refocus) {
  const sub = subEl(), root = $('[data-sk-mnav4-root]');
  if (!sub || !root || sub.hidden) return;
  sub.hidden = true; sub.innerHTML = ''; root.hidden = false;
  $('[data-mobile-nav-panel]')?.classList.remove('sk-mnav4-is-sub');
  const bk = $('[data-sk-mnav4-back]'); if (bk) bk.hidden = true;
  const t = $('[data-sk-mnav4-title]'); if (t) t.textContent = '';
  if (refocus && lastRow) lastRow.focus();
}
function back() { if (depth > 1) history.back(); else showRoot(true); }
window.addEventListener('popstate', () => {
  if (pending) { const u = pending; pending = null; quiet = 0; window.location.href = u; return; }
  if (quiet) { quiet--; return; }
  if (depth > 0) depth--;
  if (subOpen()) { showRoot(true); return; }
  if (isOpen()) closeDrawer(true);
});
document.addEventListener('click', (e) => {
  const t = e.target && e.target.closest ? e.target : null;
  if (!t) return;
  const row = t.closest('[data-sk-mnav4-open]');
  if (row) { e.preventDefault(); showSub(row.getAttribute('data-sk-mnav4-open'), row); return; }
  if (t.closest('[data-sk-mnav4-back]')) { e.preventDefault(); back(); return; }
  const acc = t.closest('.sk-mnav4__acc-btn, [data-sk-mnavs-toggle]');
  if (acc) {
    const l = document.getElementById(acc.getAttribute('aria-controls'));
    const o = acc.getAttribute('aria-expanded') === 'true';
    acc.setAttribute('aria-expanded', o ? 'false' : 'true'); if (l) l.hidden = o; return;
  }
  /* Link im offenen Drawer: History zuerst aufräumen, dann navigieren (sonst landet „Zurück“ im Menü-Zustand) */
  const link = t.closest('a[href]');
  if (link && depth > 0 && link.closest('[data-sk-mnav]') && !e.defaultPrevented && !e.metaKey && !e.ctrlKey && !e.shiftKey && link.target !== '_blank') {
    const h = link.getAttribute('href') || '';
    if (h && h.charAt(0) !== '#' && h.indexOf('tel:') !== 0 && h.indexOf('mailto:') !== 0) {
      e.preventDefault(); pending = link.href; const n = depth; depth = 0; history.go(-n);
      setTimeout(() => { if (pending) { const u = pending; pending = null; window.location.href = u; } }, 600);
      return;
    }
  }
  /* ── 8 „Live-Chat“ (#chat) öffnet das Chat-Widget (window.SKOpenChat bzw. .sk-chat__bubble), sonst Kontaktseite ── */
  const chat = t.closest('[data-sk-nav4-chat]') || t.closest('a[href="#chat"]');
  if (chat) {
    e.preventDefault();
    const fallback = () => { const b = $('[data-sk-nav4-contact]'); window.location.href = (b && b.getAttribute('data-sk-nav4-contact')) || '/pages/kontakt'; };
    if (isOpen()) closeDrawer();
    if (window.SKOpenChat) { window.SKOpenChat(fallback); return; }
    const started = Date.now();
    (function poll() {
      const bubble = $('.sk-chat__bubble');
      if (bubble) { bubble.click(); return; }
      if (Date.now() - started > 6000) { fallback(); return; }
      setTimeout(poll, 120);
    })();
  }
});
/* Chips „Schnell zur Lösung“ = Vorschläge unter dem Drawer-Suchfeld: nur bei Fokus und leerem Feld sichtbar */
let keepChips = 0;
function setChips(show) {
  const box = $('[data-sk-mnav4-chips]'), inp = $('[data-sk-mnav4-search]');
  if (!box || !inp) return;
  if (show && subOpen()) show = false;
  box.hidden = !show; inp.setAttribute('aria-expanded', show ? 'true' : 'false');
}
document.addEventListener('focusin', (e) => { if (e.target.matches && e.target.matches('[data-sk-mnav4-search]')) { buildDrawer(); setTimeout(() => setChips(!e.target.value), 0); } });
document.addEventListener('input', (e) => { if (e.target.matches && e.target.matches('[data-sk-mnav4-search]')) setChips(!e.target.value); });
document.addEventListener('pointerdown', (e) => { if (e.target.closest && e.target.closest('[data-sk-mnav4-chips]')) keepChips = 1; }, true);
document.addEventListener('focusout', (e) => {
  if (!e.target.matches || !e.target.matches('[data-sk-mnav4-search], [data-sk-mnav4-chips] a')) return;
  setTimeout(() => {
    const a = document.activeElement, box = $('[data-sk-mnav4-chips]');
    if (keepChips) { keepChips = 0; return; }
    if (box && (box.contains(a) || (a && a.matches && a.matches('[data-sk-mnav4-search]')))) return;
    setChips(false);
  }, 150);
});
/* Wisch nach rechts (> 60 px, < 30°) = eine Ebene zurück */
let sx = 0, sy = 0, st = 0;
document.addEventListener('touchstart', (e) => {
  if (!subOpen() || !e.target.closest || !e.target.closest('[data-mobile-nav-panel]')) { st = 0; return; }
  const p = e.touches[0]; sx = p.clientX; sy = p.clientY; st = 1;
}, { passive: true });
document.addEventListener('touchend', (e) => {
  if (!st) return; st = 0;
  const p = e.changedTouches[0], dx = p.clientX - sx, dy = Math.abs(p.clientY - sy);
  if (dx > 60 && dy < dx * 0.577) back();
}, { passive: true });

/* ── 6 Schlankes Handy-Menü (Sprachen ohne v4): Akkordeon aus dem Desktop-Markup sk-nav-simple ── */
const CHEV = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="m6 9 6 6 6-6"/></svg>';
function mRow(src, level) {
  const li = document.createElement('li');
  const el = document.createElement(src.tagName === 'A' ? 'a' : 'span');
  el.className = 'sk-mnavs__row';
  if (src.tagName === 'A') { el.href = src.getAttribute('href'); el.setAttribute('data-sk-level', String(level)); if (src.hasAttribute('aria-current')) el.setAttribute('aria-current', 'page'); }
  el.textContent = src.textContent.trim();
  li.appendChild(el);
  return li;
}
function mGroup(src, level, children) {
  const li = document.createElement('li');
  const id = 'sk-mnavs-' + (++uid);
  const b = document.createElement('button');
  b.type = 'button'; b.className = 'sk-mnavs__row'; b.setAttribute('aria-expanded', 'false'); b.setAttribute('aria-controls', id); b.setAttribute('data-sk-mnavs-toggle', '');
  b.innerHTML = '<span></span>' + CHEV; b.firstChild.textContent = src.textContent.trim();
  const ul = document.createElement('ul'); ul.className = 'sk-mnavs__sub'; ul.id = id; ul.hidden = true;
  if (src.tagName === 'A') { const all = mRow(src, level); all.firstChild.textContent = src.textContent.trim(); ul.appendChild(all); }
  children.forEach((c) => ul.appendChild(c));
  li.appendChild(b); li.appendChild(ul);
  return li;
}
function buildSimple() {
  const list = $('[data-sk-mnavs-list]'), bar = $('[data-sk-snav]');
  if (!list || !bar || list.childElementCount) return;
  $$(':scope > li', bar).forEach((li) => {
    const a = li.querySelector(':scope > a'), p = li.querySelector('[data-sk-nav4-panel]');
    if (!a) return;
    if (!p) { list.appendChild(mRow(a, 1)); return; }
    hydrate(p);
    const kids = $$(':scope > ul > li', p).map((l2) => {
      const lab = l2.querySelector(':scope > .sk-snav__link');
      const l3 = $$('.sk-snav__fly a', l2);
      return l3.length ? mGroup(lab, 2, l3.map((x) => mRow(x, 3))) : mRow(lab, 2);
    });
    list.appendChild(mGroup(a, 1, kids));
  });
}

/* ── 7 Warenkorb: kein eigener Code — das Icon ist ein Link .action__cart; die sk-Cart-Bridge (Cart-Agent) öffnet den sk-Drawer,
   den Zähler aktualisieren cart-icon.js (Horizon) bzw. sk-drawer.js updateCartCountBadges(). ── */
